import { getUTCDateNowWithTimezone } from "./DSDateUtils";
import { DSChannel, DSDetailAndTime, DSPlayerOBj } from "./types";

// This is a hack to get around the fact that the date is not always set.
const PAST_DATE = new Date(2000, 1, 1);
// This is a hack to get around the fact that the date is not always set.
const FUTURE_DATE = new Date(2100, 1, 1);

const dateOrPast = (date?: Date) => {
  if (!date) return PAST_DATE;
  return date;
};

const dateOrFuture = (date?: Date) => {
  if (!date) return FUTURE_DATE;
  return date;
};

const isInRange = (startDate: Date, endDate: Date, playerTimezone: string) => {
  const now = getUTCDateNowWithTimezone(playerTimezone);
  return now >= startDate && now <= endDate;
};

const weekDayCheckExpired = (timezone: string, weekDay: DSDetailAndTime<Date>) => {
  const dayOfWeek = weekDay.dayOfWeek;
  const dayMap: Record<string, number> = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };
  const dayOfWeekNumber = dayMap[dayOfWeek];
  const now = getUTCDateNowWithTimezone(timezone);

  const nowStartDateWithToday = new Date();
  nowStartDateWithToday.setHours(weekDay.startTime.getHours());
  nowStartDateWithToday.setMinutes(weekDay.startTime.getMinutes());

  const nowEndDateWithToday = new Date();
  nowEndDateWithToday.setHours(weekDay.endTime.getHours());
  nowEndDateWithToday.setMinutes(weekDay.endTime.getMinutes());

  const isInRange = now.getDay() === dayOfWeekNumber && now >= nowStartDateWithToday && now <= nowEndDateWithToday;

  return isInRange;
};

export const eliminateExpired = (player: DSPlayerOBj<Date>) => {
  const playerTimezone = player.playerTimeZone;
  const np: DSPlayerOBj<Date> = player;

  if (np.playerContent) {
    if (!isInRange(dateOrPast(np.playerContent.startDate), dateOrFuture(np.playerContent.endDate), playerTimezone)) {
      np.playerContent = undefined;
    }
  }

  if (np.playerDefaultContent) {
    if (
      !isInRange(
        dateOrPast(np.playerDefaultContent.startDate),
        dateOrFuture(np.playerDefaultContent.endDate),
        playerTimezone
      )
    ) {
      np.playerDefaultContent = undefined;
    }
  }

  if (np.playerContentGroup) {
    np.playerContentGroup.contentDetials = np.playerContentGroup.contentDetials.filter((member) => {
      return isInRange(dateOrPast(member.startDate), dateOrFuture(member.endDate), playerTimezone);
    });

    if (np.playerContentGroup.contentDetials.length === 0) {
      np.playerContentGroup = undefined;
    }
  }

  if (np.playerChannel) {
    np.playerChannel.details = np.playerChannel.details.filter((detail) => checkExpiredDetails(detail, playerTimezone));
  }

  if (np.playerChannel?.defaultContent) {
    if (
      !isInRange(
        dateOrPast(np.playerChannel.defaultContent.startDate),
        dateOrFuture(np.playerChannel.defaultContent.endDate),
        playerTimezone
      )
    ) {
      np.playerChannel.defaultContent = undefined;
    }
  }

  if (np.playerCampaigns) {
    np.playerCampaigns.forEach((campaign) => {
      campaign.details = campaign.details.filter((detail) => checkExpiredDetails(detail, playerTimezone));
      if (
        !isInRange(
          dateOrPast(campaign.defaultContent?.startDate),
          dateOrFuture(campaign.defaultContent?.endDate),
          playerTimezone
        )
      ) {
        campaign.defaultContent = undefined;
      }
    });

    np.playerCampaigns = np.playerCampaigns.filter((campaign) => {
      return campaign.details.length > 0;
    });

    if (np.playerCampaigns.length === 0) {
      np.playerCampaigns = undefined;
    }
  }

  if (np.areaContentList) {
    np.areaContentList = np.areaContentList.filter((areaContent) => {
      if (areaContent.content) {
        return isInRange(
          dateOrPast(areaContent.content.startDate),
          dateOrFuture(areaContent.content.endDate),
          playerTimezone
        );
      }

      if (areaContent.contentGroup) {
        areaContent.contentGroup.contentDetials = areaContent.contentGroup.contentDetials.filter((member) => {
          return isInRange(dateOrPast(member.startDate), dateOrFuture(member.endDate), playerTimezone);
        });

        if (areaContent.contentGroup.contentDetials.length > 0) {
          return true;
        }
      }

      return false;
    });
  }

  if (np.areaDefaultContent) {
    if (
      !isInRange(
        dateOrPast(np.areaDefaultContent.startDate),
        dateOrFuture(np.areaDefaultContent.endDate),
        playerTimezone
      )
    ) {
      np.areaDefaultContent = undefined;
    }
  }

  return np;
};

const checkExpiredDetails = (detail: DSChannel<Date>["details"][0], playerTimezone: string) => {
  if (!detail.isActive) {
    return false;
  }

  if (isInRange(dateOrPast(detail.periodStart), dateOrFuture(detail.periodEnd), playerTimezone)) {
    detail.detailDateAndTimes = detail.detailDateAndTimes.filter((detailDateAndTime) => {
      return weekDayCheckExpired(playerTimezone, detailDateAndTime);
    });

    // Need at least 1 week day config
    if (detail.detailDateAndTimes.length === 0) {
      return false;
    }

    detail.detailContents = detail.detailContents.filter((detailContent) => {
      if (detailContent.content) {
        return isInRange(
          dateOrPast(detailContent.content?.startDate),
          dateOrFuture(detailContent.content?.endDate),
          playerTimezone
        );
      }

      if (detailContent.contentGroup) {
        detailContent.contentGroup.contentDetials = detailContent.contentGroup.contentDetials.filter((member) => {
          return isInRange(dateOrPast(member.startDate), dateOrFuture(member.endDate), playerTimezone);
        });

        if (detailContent.contentGroup.contentDetials.length > 0) {
          return true;
        }
      }

      return false;
    });

    if (detail.detailContents.length === 0) {
      return false;
    }

    return true;
  }

  return false;
};
